import { FormEvent, useState } from "react";
import { Eye, EyeOff, Factory, Layers3, ShieldCheck } from "lucide-react";
import { ApiError } from "../api";
import { useAuth } from "../auth";
import { company } from "../company";

export function LoginPage() {
  const { login } = useAuth();
  const [username, setUsername] = useState("admin");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await login(username, password);
    } catch (reason) {
      setError(reason instanceof ApiError ? reason.message : "Đăng nhập không thành công.");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <main className="login-page">
      <section className="login-intro">
        <div className="login-brand">
          <img className="login-logo" src={company.logoPath} alt={`Logo ${company.brandName}`} />
          <div>
            <strong>{company.brandName}</strong>
            <span>MEDICAL ERP</span>
          </div>
        </div>
        <div className="login-message">
          <span className="eyebrow">KHUNG QUẢN TRỊ THEO ISO</span>
          <h1>Một trục dữ liệu xuyên suốt từ nguyên liệu đến khách hàng</h1>
          <p>
            Quản lý sản phẩm, lô, BOM, sản xuất, chất lượng và truy xuất trên cùng một
            hệ thống.
          </p>
          <div className="login-features">
            <div><Layers3 size={22} /> Dữ liệu tập trung</div>
            <div><Factory size={22} /> Sản xuất theo lô</div>
            <div><ShieldCheck size={22} /> Kiểm soát QC/QA</div>
          </div>
        </div>
        <footer>
          <strong>{company.legalName}</strong>
          <span>{company.address}</span>
          <span>
            MST: {company.taxCode} · {company.phone} · {company.email} · {company.website}
          </span>
        </footer>
      </section>

      <section className="login-panel">
        <form className="login-card" onSubmit={submit}>
          <span className="eyebrow">ĐĂNG NHẬP HỆ THỐNG</span>
          <h2>Chào mừng trở lại</h2>
          <p>Sử dụng tài khoản đã được cấp để tiếp tục.</p>
          <label>
            Tên đăng nhập
            <input
              value={username}
              onChange={(event) => setUsername(event.target.value)}
              autoComplete="username"
              autoFocus
              required
            />
          </label>
          <label>
            Mật khẩu
            <span className="password-input-wrap">
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                autoComplete="current-password"
                required
              />
              <button
                type="button"
                className="password-visibility"
                onClick={() => setShowPassword((visible) => !visible)}
                title={showPassword ? "Ẩn mật khẩu" : "Hiện mật khẩu"}
                aria-label={showPassword ? "Ẩn mật khẩu" : "Hiện mật khẩu"}
              >
                {showPassword ? <EyeOff size={19} /> : <Eye size={19} />}
              </button>
            </span>
          </label>
          {error && <div className="form-error">{error}</div>}
          <button className="primary-button login-submit" type="submit" disabled={submitting}>
            {submitting ? "Đang đăng nhập..." : "Đăng nhập"}
          </button>
          <div className="login-help">
            Tài khoản lần đầu: <strong>admin</strong> / <strong>Admin@123</strong>
          </div>
        </form>
      </section>
    </main>
  );
}
